import { httpClient } from "lib/axios";
import { isCounterAdmin,getCounterId } from "pages/Auth/permissionGuard";

export const return_api = {
  get_returns: async counter => {
    let url = `return_stock/`;
    if (isCounterAdmin()) {
      url = `return_stock/?counter_id=${counter}`;
    }else{
      url = `return_stock/`;
    }
    return await httpClient
      .get(url)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  get_reasons: async () => {
    return await httpClient
      .get(`return_stock/?reason=true`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  change_transfer_status: async payload => {
    return await httpClient.post(`stock_transfer/`, payload);
  },
  get_products: async () => {
    return await httpClient
      .get(`stock_list/?product=true`)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  transfer_stock: async payload => {
    return await httpClient.post(`stock_list/`, payload);
  },
  edit_stock_transfer: async payload => {
    return await httpClient.put(`stock_list/`, payload);
  },
  add_return_stock: async payload => {
    return await httpClient
      .post(`return_stock/`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  edit_return_stock_qty: async payload => {
    return await httpClient
      .put(`return_stock/`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  edit_return_stock_status: async payload => {
    return await httpClient
      .put(`return_stock/?status=accept`, payload)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  lookup_invoice: async invoice_no => {
    return await httpClient
      .get(`invoice/return-lookup/?invoice_no=${invoice_no}`)
      .then(res => res.data)
      .catch(err => err);
  },
  get_replacements_report: async (start_date, end_date, pageNumber = 1, pageSize = 10, search = "", original_bill = "", replacement_bill = "", customer_name = "", operator_name = "", for_csv = false) => {
    let url = `invoice/replacements-report/?page_number=${pageNumber}&page_size=${pageSize}`;
    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (original_bill) url += `&original_bill=${encodeURIComponent(original_bill)}`;
    if (replacement_bill) url += `&replacement_bill=${encodeURIComponent(replacement_bill)}`;
    if (customer_name) url += `&customer_name=${encodeURIComponent(customer_name)}`;
    if (operator_name) url += `&operator_name=${encodeURIComponent(operator_name)}`;
    if (for_csv) url += `&for_csv=true`;
    
    return await httpClient
      .get(url)
      .then(res => res.data)
      .catch(err => err);
  },
};
